module.exports = __webpack_public_path__ + "static/img/2.938a6a49.jpg";